"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _utils = require("../../utils");
/**
 * Set transformed video inputs, allows the persistence of the transformed
 * video inputs so they can be reused
 * @param inputs
 * @returns {(function(*): void)|*}
 */
function setTransformedVideoInputs(inputs) {
  return (0, _utils.actionCreator)(_types.BROADCAST_SET_TRANSFORMED_VIDEO_INPUTS, inputs);
}
var _default = exports["default"] = setTransformedVideoInputs;